import React from 'react';
import { Input, InputGroup, Label } from 'reactstrap';

import styles from './PaymentsInput.module.scss';

interface IProps {
  label?: string;
  name: string;
  onChange?: any;
  type?: 'email';
}

function PaymentsInput({ label, name, onChange, type }: IProps) {
  return (
    <>
      <InputGroup className={styles.inputContainer}>
        <Label className={styles.label}>{label}</Label>

        <Input
          className={styles.input}
          autoComplete="off"
          name={name}
          onChange={onChange}
          type={type}
        />
      </InputGroup>
    </>
  );
}

export default PaymentsInput;
